var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 25.792 4.315 2.877V10.483c0-2.22 2.877-2.09 4.315-1.747.685.274 2.24 1.007 2.98 1.747.924.924 5.137 4.212 5.959 5.856.82 1.644.41 3.493-1.337 3.904s-3.185-.41-4.11-2.055c-.74-1.316.65-2.877 1.439-3.494l-2.877-2.877c-.685.479-2.22 1.726-2.877 2.876-.822 1.439-.822 3.493.822 6.575 1.644 3.084 7.09 4.522 10.788 2.056 3.698-2.465 3.185-6.472 2.568-7.602-.616-1.13-9.04-12.124-15-11.713C3.22 4.341 1.342 7.848 1 9.561v16.232z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.993 10.484v18.185L31 25.79V10.484c0-1.85-1.438-6.473-6.267-6.473-3.863.001-6.61 2.467-7.5 3.7l3.185 1.85c1.13-.275 2.568-.823 4.315-.823s1.815 1.165 2.26 1.747z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdx);
export default __webpack_public_path__ + "static/media/MDX.8a2202c049a26b90f4e75806c71b6b81.svg";
export { ForwardRef as ReactComponent };